<template>
  <div class="text-sm mt-2">
    <div class="d-flex overflow-auto">
      <div class="col mb-2 pl-0" v-for="(coluna, i) in colunas" :key="coluna.titulo + i">
        <b-card :title="coluna.titulo">
          <div class="overflow-auto kanban-card">
            <draggable class="draggable-list" :list="items[i]" group="items">
              <fcc-kanban-card
                v-for="(item, j) in items[i]"
                :item="item"
                :key="`${j} + ${i}`"
                @click-item="editItem"
                @delete-item="deleteItem"
              />
              <fcc-button
                class="w-100"
                slot="footer"
                @click="$emit('adicionar-item', coluna)"
                color="outline-primary"
                icon="plus"
              >
                {{ addButtonText }}</fcc-button
              >
            </draggable>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import fccKanbanCard from './fccKanbanCard.vue'

export default {
  components: { fccKanbanCard, draggable },
  props: {
    colunas: {
      type: Array,
      default: () => []
    },
    originalItems: {
      type: Array,
      default: () => []
    },
    addButtonText: {
      type: String,
      default: 'Adicionar'
    },
    columnField: {
      type: String,
      default: 'tpsituacaodetalhe'
    }
  },
  data() {
    return {
      items: [],
      oldItems: []
    }
  },
  watch: {
    originalItems: {
      handler(value) {
        this.items = value
      },
      immediate: true
    },
    items: {
      handler(value) {
        const objMudado = this.findMovedObjects(this.oldItems, value)
        const coluna = this.colunas[objMudado[0]?.toColumn]
        if (objMudado && coluna) {
          this.$emit('item-movido', {
            obj: objMudado[0].obj,
            columnId: coluna[this.columnField]
          })
        }

        this.$nextTick(() => {
          this.oldItems = JSON.parse(JSON.stringify(value))
        })
      },
      deep: true
    }
  },
  methods: {
    editItem(item) {
      this.$emit('edit-item', item)
    },
    deleteItem(item) {
      this.$emit('delete-item', item)
    },
    findMovedObjects(before, after) {
      const changes = []

      const afterColumnMap = new Map()
      for (let c = 0; c < after.length; c++) {
        for (let obj of after[c]) {
          afterColumnMap.set(obj.iddetalhe, c)
        }
      }

      for (let c = 0; c < before.length; c++) {
        for (let obj of before[c]) {
          const id = obj.iddetalhe

          if (!afterColumnMap.has(id)) {
            continue
          }

          const newColumn = afterColumnMap.get(id)

          if (newColumn !== c) {
            changes.push({
              obj,
              fromColumn: c,
              toColumn: newColumn
            })
          }
        }
      }

      return changes
    }
  }
}
</script>

<style scoped>
.kanban-card {
  height: 500px;
  width: 300px;
}

.draggable-list {
  min-height: 500px;
}
</style>